
<template>



    <section>
          <b-container>
            <b-row align-v="center" class="row-grid">
              <b-col md="6" class="order-md-2">
                <b-img src="img/custom/byond.png" fluid />
              </b-col>
              <b-col md="6" class="order-md-1">
                <div class="pr-md-5">
                  <h1>Please provide your contact data</h1>
    
                        
                  <p>
                            <base-input prepend-icon="fas fa-user" placeholder="Your first name" v-model="currentSnapWizard.firstname" name="First name" rules="required|alpha_spaces"></base-input>
    
                            <base-input prepend-icon="fas fa-user" placeholder="Your last name" v-model="currentSnapWizard.lastname" name="Last name" rules="required|alpha_spaces"></base-input>
                  </p>
                        
    
                        <p>
                            <base-input prepend-icon="fas fa-globe" placeholder="Your email" v-model="currentSnapWizard.email" name="email" rules="required|email"></base-input>
               
                            <base-input prepend-icon="fas fa-globe" placeholder="instagram/website" v-model="currentSnapWizard.instagram" name="instagram" rules="required|alpha_num"></base-input>
                        </p>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </section>
    
    
       
    
    </template>
    
    
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import TagsInput from '@/components/Inputs/TagsInput'

export default {
    name: 'snap05',
    components: {
        TagsInput,
        [Tooltip.name]: Tooltip
    },
    methods: {
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
            if (
                this.currentSnapWizard.firstname != "" && this.currentSnapWizard.firstname != undefined &&
                this.currentSnapWizard.lastname != "" && this.currentSnapWizard.lastname != undefined && 
                this.currentSnapWizard.instagram != "" && this.currentSnapWizard.instagram != undefined && 
                this.currentSnapWizard.email != "" && this.currentSnapWizard.email != undefined
            ) {
                //this.claim.allValidated = true;
                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                this.$emit('showFooterNav');
                return true;
            }
            this.$emit('denyProceed');
            this.$emit('hideFooterNav');
            return false;
        },
    },
    computed: {
        ...mapGetters({
            currentSettings: 'currentSettings',
            currentSnapWizard: 'currentSnapWizard',
            currentSnapWizardStep: 'currentSnapWizardStep',
        }),
        show_images_hint() {
            if(this.currentSnapWizard.images_ready == 1){
                return true;
            }
            else{
                return false;
            }
        },
    },
    watch: {
        currentSnapWizard: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
                this.allDataValidated();
            },
            deep: true
        },
    },
    mounted() {
        this.$emit('denyProceed');
        this.allDataValidated();
    }
};
</script>